import { getCountries, getCountryCallingCode, parsePhoneNumberFromString } from "libphonenumber-js";

const fallbackNames = {
  AC: "Ascension Island",
  TA: "Tristan da Cunha",
  XK: "Kosovo",
};

const displayNames = typeof Intl.DisplayNames === "function"
  ? new Intl.DisplayNames(["en"], { type: "region" })
  : null;

export const countryOptions = getCountries()
  .map((iso) => ({
    iso,
    name: fallbackNames[iso] || displayNames?.of(iso) || iso,
    callingCode: getCountryCallingCode(iso),
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

const countryAliases = new Map([
  ["united states of america", "US"],
  ["usa", "US"],
  ["u.s.a.", "US"],
  ["uk", "GB"],
  ["u.k.", "GB"],
  ["uae", "AE"],
]);

export function countryIsoFromName(value) {
  const normalized = String(value || "").trim().toLowerCase();
  if (!normalized) return "";
  const alias = countryAliases.get(normalized);
  if (alias) return alias;
  return countryOptions.find((country) => country.name.toLowerCase() === normalized)?.iso || "";
}

export function phoneDetails(member) {
  const number = String(member?.phoneNumber || "").trim();
  const country = String(member?.phoneCountry || "").toUpperCase();
  if (!number) return null;
  try {
    const parsed = parsePhoneNumberFromString(number, country || undefined);
    if (parsed) {
      const international = parsed.number;
      return {
        display: parsed.formatInternational(),
        telHref: `tel:${international}`,
        whatsappHref: `https://wa.me/${international.replace(/\D/gu, "")}`,
      };
    }
  } catch {
    // Fall through to a conservative digits-only link for incomplete legacy input.
  }
  const digits = number.replace(/\D/gu, "");
  if (!digits) return null;
  const callingCode = country ? countryOptions.find((option) => option.iso === country)?.callingCode : "";
  const internationalDigits = `${callingCode || ""}${digits.replace(/^0+/u, "")}`;
  return {
    display: `${callingCode ? `+${callingCode} ` : ""}${number}`,
    telHref: `tel:+${internationalDigits}`,
    whatsappHref: callingCode ? `https://wa.me/${internationalDigits}` : "",
  };
}
